import { DashboardService } from './../dashboard/dashboard.service';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SelectEventArgs, TabComponent, TabItemModel, TabModule } from '@syncfusion/ej2-angular-navigations';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { IDashboardDTO } from 'src/app/base/models/models.swagger.generated';
import { TabSettingsComponent } from "./tab-settings-widget/tab-settings.component";
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dashboard-oversight',
    imports: [TabModule, TranslateModule, CommonModule, TabSettingsComponent],
    templateUrl: './dashboard-oversight.component.html',
    styleUrl: './dashboard-oversight.component.scss'
})
export class DashboardOversightComponent implements AfterViewInit, OnDestroy {

  @ViewChild('tabObj')
  public tabObj: TabComponent;

  @ViewChild('editTabsWidgetDialog')
  public editTabsWidgetDialog: TabSettingsComponent;

  @ViewChild('tabContent', { read: ViewContainerRef })
  tabContent: ViewContainerRef;

  public animation: object = {
    previous: { effect: "", duration: 0, easing: "" },
    next: { effect: "", duration: 0, easing: "" }
  };

  public tabBarWith = 0;

  private subscriptions: Subscription = new Subscription();
  protected isEditMode = false;

  private componentRefs = new Map<number, any>();

  constructor(
    private dashboardService: DashboardService
  ) { }

  ngAfterViewInit() {
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public toggleEditMode() {
    this.isEditMode = !this.isEditMode;
    // reset all dashboards
    this.resetTabsForRefresh();
  }

  public refreshWidgetData() {
    this.resetTabsForRefresh();
  }

  public addWidget() {
    const selectedTabId = this.tabObj.selectedItem;
    const dashboardId = Number(this.tabObj.items[selectedTabId].id);
    const componentRef = this.componentRefs.get(dashboardId);
    if (componentRef) {
      componentRef.instance.addWidget();
    }
  }

  public tabGroupCreated() {
    this.subscriptions.add(
      this.dashboardService.dashboards$.subscribe(dashboards => {
        this.addTabItems(dashboards);
        setTimeout(() =>
          this.setTabBarWidth()
        ), 0;
      })
    );
  }

  //Will be used later on
  // draggedTabItem(args: DragEventArgs) {
  //   setTimeout(() => {
  //     const newOrder = this.tabObj.items;
  //     const updateRequests = [];

  //     newOrder.forEach((tab, index) => {
  //       const dashboard = this.dashboardService.dashboards.find(d => d.id.toString() === tab.id);
  //       if (dashboard && dashboard.tabGroupIndex !== index) {
  //         dashboard.tabGroupIndex = index;
  //         updateRequests.push(this.dashboardService.updateDashboard(dashboard));
  //       }
  //     });

  //     if (updateRequests.length > 0) {
  //       combineLatest(updateRequests).subscribe(() => {
  //         this.tabObj.refresh();
  //       });
  //     }
  //   }, 0);
  // }

  public onTabSelected(args: SelectEventArgs) {
    // build the content of the selected tab only when needed
    const tabItem = this.tabObj.items.at(args.selectedIndex);
    if (tabItem != null) {
      if (tabItem.content == null || tabItem.content === "") {
        tabItem.content = this.createDashboardComponent(+tabItem.id);
      }
      this.tabObj?.refresh();
    }
  }

  addTabItems(dashboards: IDashboardDTO[]) {
    const tabItems: TabItemModel[] = dashboards.map(dashboard => ({
      id: dashboard.id.toString(),
      header: { text: dashboard.name ?? 'Dashboard' },
      content: undefined
    }));
    const selectedItem = this.tabObj.selectedItem;
    if (tabItems.length > selectedItem) {
      tabItems[selectedItem].content = this.createDashboardComponent(dashboards[selectedItem].id);
    }
    this.tabObj.items = tabItems;
  }

  createDashboardComponent(dashboardId: number): HTMLElement {
    const componentRef = this.tabContent.createComponent(DashboardComponent);
    componentRef.instance.dashboardId = dashboardId;
    componentRef.instance.isEditMode = this.isEditMode;
    this.componentRefs.set(dashboardId, componentRef);

    const div = document.createElement('div');
    div.appendChild(componentRef.location.nativeElement);
    return div;
  }

  public openTabSettings() {
    this.editTabsWidgetDialog.showEditTabSettings();
  }

  public setTabBarWidth() {
    this.tabBarWith = document.getElementById('element_tab_header_items')?.clientWidth ?? document.getElementById('e-item-element_0')?.clientWidth ?? 0;
  }

  private resetTabsForRefresh(): void {
    // reset all dashboards and refresh only the selected one
    this.tabObj.items.forEach((item, index) => {
      if (index == this.tabObj.selectedItem) {
        item.content = this.createDashboardComponent(+item.id);
      } else {
        item.content = "";
      }
    });
    this.tabObj.refresh();
  }

}
